export default __webpack_public_path__ + "static/media/wave3.d75e926c.png";